import ElementModalCostume from "../../../../shared/Components/ElementModalCostume";
import { LanguageTranslate } from "../../../../shared/Infraestructure/LanguageTranslate";
import { EntityModalPermiss } from "../../Domain/Utils"

interface IProps {
    modalPermiss: EntityModalPermiss;
    closeModal(): void;
    onChangeOptionsPermiss(option: number): void;
    onSubmit(): Promise<void>
}

export const ModalPermissNotification = (props: IProps) => {
    const language = LanguageTranslate();

    return (
        <ElementModalCostume
            show={props.modalPermiss.show}
            closeModal={props.closeModal}
            title={language.moduloNotificacion.modalForm.title}
            height="360px"
        >
            <div>
                <p>
                    {language.moduloNotificacion.modalForm.descripcion1}
                </p>
                <p>
                    {language.moduloNotificacion.modalForm.descripcion2}
                </p>

                <label style={{ fontSize: 14, marginBottom: 12 }}>
                    <input type="checkbox" checked={props.modalPermiss.options.includes(1)} onChange={() => props.onChangeOptionsPermiss(1)} />&nbsp;&nbsp;{language.moduloNotificacion.form.opcionAprobacion}
                </label>

                <label style={{ fontSize: 14, marginBottom: 20 }}>
                    <input type="checkbox" checked={props.modalPermiss.options.includes(2)} onChange={() => props.onChangeOptionsPermiss(2)} />&nbsp;&nbsp;{language.moduloNotificacion.form.opcionGrupal}
                </label>

                <div style={{ margin: 'bottom', width: '100%', height: 1 }} />

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <button className="btn btn-primary w-100" onClick={() => props.onSubmit()}>{language.moduloNotificacion.modalForm.buttonActive}</button>
                    <button className="btn btn-danger w-100" onClick={() => props.closeModal()}>{language.moduloNotificacion.modalForm.buttonDenied}</button>
                </div>
            </div>
        </ElementModalCostume>
    )
}